import React, { useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  SearchFacets,
  SearchFacetMenuRadios,
  SearchFacetRefinementCheckboxes,
} from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import { facetAttributes } from '../config';

import './style.scss';

const Facets: React.FC = () => {
  const { t } = useTranslation();

  const MAPPED_LABELS = ['maatje_worden', 'maatje_zoeken'];

  const transformTypeItems = useCallback((items: any[]) => items.map((item) => ({
    ...item,
    label: MAPPED_LABELS.includes(item.value)
      ? t(`searchkit.facets.radios.label_mappings.${item.value}`)
      : item.label,
  })), []);


  return (
    <>
      {facetAttributes.map((facetAttribute) => {
        const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

        const isAttributeRequestType = attribute === 'field_request_type';

        const Facet = !isAttributeRequestType
          ? SearchFacetRefinementCheckboxes
          : SearchFacetMenuRadios;

        return (
          <Facet
            key={attribute}
            title={t(`searchkit.facets.${attribute}.label`)}
            attribute={attribute}
            sortBy={['name:asc']}
            transformItems={transformTypeItems}
            className={`SearchMaatjesProjects__Facets__${attribute}`}
          />
        );
      })}
    </>
  );
};

interface SearchMaatjesProjectsFacetsProps extends SearchFacetsProps {
  dialogEnabled?: boolean;
}

const SearchMaatjesProjectsFacets: React.FC<SearchMaatjesProjectsFacetsProps> = (props) => {
  const {
    className,
    ...restProps
  } = props;

  const classNames = c('SearchMaatjesProjects__Facets', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      <Facets />
    </SearchFacets>
  );
};

export default SearchMaatjesProjectsFacets;
